/* global _ Waypoint Swiper anime  */

(function () {
	"use strict";

	// function to navigate to a section in the page with smooth scroll
	function smoothScroll(targetId) {

		const targetElement = document.getElementById(targetId);

		if (targetElement) {
			const offsetTop = targetElement.offsetTop + 100;
			window.scrollTo({
				top: offsetTop,
				behavior: "smooth"
			});
		}
	}

	// replay the story
	const replayStoryBtn = document.querySelector(".js-replay-button");
	if( replayStoryBtn ){
		replayStoryBtn.addEventListener("click", () => smoothScroll("desktop_top"));
	}

	// function to attach to the desktop paging for scrollong between the stories
	function attachClickEvents(pagingElements) {
		pagingElements.forEach(element => {
			element.addEventListener("click", function(event) {
				event.preventDefault();
				smoothScrollToTarget.call(this, event);
			});
		});
	}

	// function to smoothly scroll between the stories on desktop paging
	function smoothScrollToTarget() {
		const targetID = this.getAttribute("data-story");
		const targetElement = document.getElementById(targetID);

		if (targetElement) {
			targetElement.scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		}
	}

	// function to remove the active style on desktop paging
	function removeActiveClass() {
		const pagingEl = document.querySelectorAll(".js-paging");
        pagingEl.forEach(function(link) {
            link.classList.remove("active");
        });
    }

	/**
	 * hero heading animation
	 */

	const heroHeading = document.querySelector(".js-replay-button");

	if (heroHeading) {
		anime({
			targets: ".js-dilo-hero-heading",
			opacity: [0, 1],
			delay: 1000 // increase delay by 100ms for each elements.
		});

		anime({
			targets: ".js-dilo-hero-heading span",
			translateY: [30, 0],
			delay: anime.stagger(50, {easing: "easeOutSine", start: 1000}) // increase delay by 100ms for each elements.
		});

		anime({
			targets: ".js-dilo-person",
			translateY: [-30, 0],
			opacity: [0, 1],
			delay: anime.stagger(100, {easing: "easeOutSine", start: 1300, direction: "reverse"})
		});

		anime({
			targets: ".js-dilo-hero-btn",
			opacity: [0, 1],
			translateY: [-60, 0],
			duration: 100,
			delay: 1600 // increase delay by 100ms for each elements.
		});

		anime({
			targets: ".js-dilo-quote",
			translateY: [-30, 0],
			opacity: [0, 1],
			delay: anime.stagger(100, {easing: "easeOutSine", start: 1300, direction: "reverse"})
		});
	}


	/**
	 *
	 * Story video and scroll controller funtion for desktop
	 */
	function videoScrollHandler(video, playSeconds, stopSeconds, index) {
		var videoNumber = document.querySelector("#videoCount");
		var videoPlayer = document.querySelector(".js-videoPlayer");

		// This function will be called by the Waypoint handlers
		return function() {
			// Update the video number
			videoNumber.innerHTML = index + 1;
			// Remove active class from all other links (this should be defined elsewhere)
			removeActiveClass();
			// Find and activate the corresponding link
			var storyId = video.id; // e.g., "story_1"
			var correspondingLink = document.querySelector(`.js-paging[data-story="${storyId}"]`);
			if (correspondingLink) {
				correspondingLink.classList.add("active");
			}
			// Control the video player
			videoPlayer.currentTime = playSeconds;
			videoPlayer.play();
			videoPlayer.muted = false;

			// Set up a function to monitor time updates and stop the video at the designated time
			var onTimeUpdate = function() {
				if(Math.floor(videoPlayer.currentTime) >= stopSeconds) {
					videoPlayer.removeEventListener("timeupdate", onTimeUpdate);
					videoPlayer.pause();
				}
				else {
					videoPlayer.play();
				}
			};

			// Add the event listener to handle time updates
			videoPlayer.addEventListener("timeupdate", onTimeUpdate);
		};
	}


	function diloStoryDesktop() {

		// var stories = document.querySelectorAll(".storyWrapper > .story");
		var storyWrappers = document.querySelectorAll(".storyWrapper");
		var videoPlayer = document.querySelector(".js-videoPlayer");
		var mainContent = document.querySelector(".j-main-container");
		var headerDiv = document.querySelector(".headerDiv");
		var waypoints = [];

		if(!videoPlayer) {
			return false;
		}

		videoPlayer.muted = true;

		storyWrappers.forEach(function(video, index) {


			var startTime = video.getAttribute("data-start");
			var stopTime = video.getAttribute("data-stop");

			var parts = startTime.split(":");

			var hours = parseInt(parts[0], 10);
			var minutes = parseInt(parts[1], 10);
			var seconds = parseInt(parts[2], 10);

			var playSeconds = hours * 3600 + minutes * 60 + seconds;

			var parts2 = stopTime.split(":");
			var hours2 = parseInt(parts2[0], 10);
			var minutes2 = parseInt(parts2[1], 10);
			var seconds2 = parseInt(parts2[2], 10);

			var stopSeconds = hours2 * 3600 + minutes2 * 60 + seconds2;

			var handlerFunction = videoScrollHandler(video, playSeconds, stopSeconds, index);

			var waypointVidoes = new Waypoint({
				element: video,
				handler: handlerFunction,
				offset: "30%"
			});

			var waypointVidoesUp = new Waypoint({
				element: video,
				handler: handlerFunction,
				offset: "-70%"
			});

			waypoints.push(waypointVidoes, waypointVidoesUp);

		});

		// Waypoint to stop video when headerDiv is 50% on viewport

		const backButton = document.querySelector(".js-back-button");

		var footerUp = new Waypoint({
			element: mainContent,
			handler: function(direction) {
				if (direction === "down") {
					backButton.classList.add("hidden");
				} else {
					backButton.classList.remove("hidden");
				}
			},
			offset: "bottom-in-view"
		});

		var headerUp = new Waypoint({
			element: headerDiv,
			handler: function(direction) {
				if (direction === "down") {
					backButton.classList.remove("hidden");
				} else {
					backButton.classList.add("hidden");
				}
			},
			offset: "-90%"
		});

		waypoints.push(footerUp, headerUp);
	}

	function handleResize() {
		var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

		if (viewportWidth >= 768) {
			diloStoryDesktop();
		}
	}

	document.addEventListener("DOMContentLoaded", function() {

		handleResize();


		window.addEventListener("resize", _.debounce(function() {
			handleResize();
		}, 250)); // Adjust debounce delay as needed

	});

	/**
	 * mobile video playback
	 */

	function pauseAndResetVideos() {
		document.querySelectorAll(".js-mvideo").forEach((video) => {
			video.pause();
			video.currentTime = 0;
		});
	}

	function controlVideoPlayback(content) {
		// Pause and reset all videos
		pauseAndResetVideos();

		// Find the video player within the same `.js-mstory` parent and play it
		const videoPlayer = content.closest(".js-mstory").querySelector(".js-mvideo");
		if (videoPlayer) {
			videoPlayer.play();
			videoPlayer.muted = false;
		}
	}

	function playVideoForVisibleContent() {
		const videoContents = document.querySelectorAll(".js-mvideo-content");
		var videoPlayers = document.querySelectorAll(".js-mvideo");

		// Loop through each video element and mute it
		videoPlayers.forEach(function(video) {
			video.muted = true; // Set the muted property to true
		});

		videoContents.forEach((content) => {
			// Waypoint for scrolling down
			new Waypoint({
				element: content,
				handler: function(direction) {
					if (direction === 'down') {
						controlVideoPlayback(content);
					}
				},
				offset: '75%' // Trigger when the element is 75% into the viewport from the top
			});

			// Waypoint for scrolling up
			new Waypoint({
				element: content,
				handler: function(direction) {
					if (direction === 'up') {
						controlVideoPlayback(content);
					}
				},
				offset: '-40%' // Trigger when the element has passed 40% of the viewport from the bottom
			});
		});
	}

	function handleMobileResize() {
		var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

		if (viewportWidth < 768) {
			playVideoForVisibleContent();
		} else {
			pauseAndResetVideos();
		}
	}

	document.addEventListener("DOMContentLoaded", function() {
		handleMobileResize();

		// Assuming you have a debounce function available, such as through Lodash (_.debounce)
		window.addEventListener("resize", _.debounce(function() {
			handleMobileResize();
		}, 250)); // Adjust debounce delay as needed
	});



	/*
	* product tour scripts
	*/

	// product tour carousel

	const dayLifeSliderContainers = document.querySelectorAll(".js-daylife-slider");
	const dayLifeSliderNavs = document.querySelectorAll(".js-dilo-slider-nav");

	const initDayLifeSwiper = (sliderContainer, sliderNav) => {

		const swiper = new Swiper(sliderContainer, {
			slidesPerView: 3,
			spaceBetween: 20,
			centeredSlides: false,
			autoplay: false,
			autoHeight: false,
			loop: false,
			navigation: {
				nextEl: sliderNav.querySelector(".js-next-dayslide"),
				prevEl: sliderNav.querySelector(".js-prev-dayslide")
			},
			pagination: {
				el: sliderNav.querySelector(".js-daylife-paging"),
				clickable: true
			},
			breakpoints: {
				320: {
					slidesPerView: 1
				},
				640: {
					slidesPerView: 2
				},
				940: {
					slidesPerView: 3
				}
			},
			on: {
				init: function(){

				}
			}
		});

		sliderContainer.classList.remove("opacity-0");
        sliderNav.classList.remove("opacity-0");

        return swiper;
	};

	const handleDayLifeSwipers = () => {
        dayLifeSliderContainers.forEach((sliderContainer, index) => {
            const sliderNav = dayLifeSliderNavs[index];
            if (sliderContainer && sliderNav) {
                initDayLifeSwiper(sliderContainer, sliderNav);
            }
        });
    };

    if (dayLifeSliderContainers.length > 0) {
        window.addEventListener("load", handleDayLifeSwipers);
        window.addEventListener("resize", handleDayLifeSwipers);
    }

	// hover text change
	// Select all elements with the class 'js-pt-storyBox'
	const storyBoxes = document.querySelectorAll(".js-pt-storyBox");

	// Check if there are any '.js-pt-storyBox' elements on the page
	if (storyBoxes.length > 0) {
		storyBoxes.forEach(storyBox => {

			storyBox.addEventListener("mouseover", () => {
				const screenshot = storyBox.querySelector(".js-pt-screenshot");
				const content = storyBox.querySelector(".js-pt-content");
				const hover = storyBox.querySelector(".js-pt-hover");

				// Add 'hidden' class to 'js-pt-screenshot' and 'js-pt-content'
				if (screenshot) screenshot.classList.add("opacity-0");
				if (content) content.classList.add("opacity-0");

				// Remove 'hidden' class from 'js-pt-hover'
				if (hover) hover.classList.remove("opacity-0");
			});

			// Mouseout event
			storyBox.addEventListener("mouseout", () => {
				const screenshot = storyBox.querySelector(".js-pt-screenshot");
				const content = storyBox.querySelector(".js-pt-content");
				const hover = storyBox.querySelector(".js-pt-hover");

				// Remove 'hidden' class from 'js-pt-screenshot' and 'js-pt-content'
				if (screenshot) screenshot.classList.remove("opacity-0");
				if (content) content.classList.remove("opacity-0");

				// Add 'hidden' class back to 'js-pt-hover'
				if (hover) hover.classList.add("opacity-0");
			});
		});
	}

	// dilo story pagination
	document.addEventListener("DOMContentLoaded", function() {
		const pagingElements = document.querySelectorAll(".js-paging");

		if (pagingElements.length > 0) {
			attachClickEvents(pagingElements);
		}

		function handleHashChange() {
			const queryParams = new URLSearchParams(location.search);
			if (queryParams.has('story')) {
				const storyValue = queryParams.get('story');
				const tourAnchor = document.querySelector('.js-ptour-anchor[data-story="' + storyValue + '"]');
				if (tourAnchor) {
					tourAnchor.click();
				}
			}
		}

		handleHashChange();

		window.addEventListener('hashchange', handleHashChange);
	});

})();
